angular.module( 'acme.view.application.programs.detail.upsells', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.view.application.programs.detail.upsells.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsDetailUpsells = {
        name: 'application.programsDetail.upsells',
        url: '/upsells?force',
        views: {
          "subview-main": {
            controller: 'ProgramsDetailUpsellsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/detail/upsells/upsells.tpl.html'
          }
        },
        data: {
          pageTitle: 'Upsells',
          pageClass: 'application application-programs-detail',
          features: {
            objectLock: {
              type: 'EventTemplate',
              views: ['application.templates.edit', 'application.programsDetail.upsells']
            }
          }
        },
        resolve: {
          ResolveTemplatesData: ['ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.program.names(false, HelpersService.getPaginator());
          }]
        }
      };

    $stateProvider
      .state(programsDetailUpsells);
});
